/**
 * Messages exchanged between the global shell (manager.dual-link.com, AppMode = shell)
 * and the cluster manager it embeds in an iframe (AppMode = manager, opened with
 * ?embedded=1). Both sides live in this codebase; see docs/CLUSTER_SHELL_PLAN.md.
 *
 * Every message is a plain object with a `type` and travels through
 * window.postMessage with an explicit target origin. Nothing sensitive ever goes
 * in the URL.
 */
class ShellMessage
{
    // manager -> shell
    static readonly ManagerReady   = "dl-manager-ready";   // { version }
    static readonly SessionAck     = "dl-session-ack";     // { businessID }
    static readonly SessionError   = "dl-session-error";   // { reason }
    static readonly SessionExpired = "dl-session-expired"; // a request got 401
    static readonly ShowWorkspace  = "dl-show-workspace";  // topbar workspace button

    // shell -> manager
    static readonly Session        = "dl-session";         // ShellSession
}

interface ShellSessionUser
{
    id:string;
    email:string;
    name:string;
}

/** What the shell hands over: the business-scoped token and the /business item. */
interface ShellSession
{
    type:string;
    accessToken:string;
    user:ShellSessionUser;
    business:any;
}

function ShellOriginOfURL(url:string):string
{
    if (url == null) return null;
    try {
        return new URL(url).origin;
    }
    catch (e) {
        return null;
    }
}

/** The per-business server map from /business, which arrives as a dictionary or as its JSON text. */
function ShellBusinessURLs(item:any):any
{
    let urls = item != null ? item["urls"] : null;
    if (typeof urls == "string") {
        try {
            urls = JSON.parse(urls);
        }
        catch (e) {
            urls = null;
        }
    }
    return urls != null ? urls : {};
}
